/* eslint-disable */

<template>
  <div class="create_login">
    <!-- Modal -->
    <div
      class="modal fade"
      id="create_login"
      tabindex="-1"
      role="dialog"
      aria-labelledby="loginTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="tab-content" id="pills-tabContent">
              <div
                class="tab-pane fade"
                id="pills-register"
                role="tabpanel"
                :class="modalType == 'register' ? 'show active' : ''"
                aria-labelledby="pills-register-tab"
              >
                <h5 class="text-center">Create New Account</h5>

                <div class="form-group">
                  <label for="name">Your name</label>
                  <input
                    type="text"
                    v-model="name"
                    class="form-control"
                    id="name"
                    placeholder="Your Name"
                  />
                </div>

                <div class="form-group">
                  <label for="name">Your Address</label>
                  <input
                    type="text"
                    v-model="address"
                    class="form-control"
                    id="address"
                    placeholder="Your Address"
                  />
                </div>

                <div class="form-group">
                  <label for="name">Phone</label>
                  <input
                    type="text"
                    v-model="phone"
                    class="form-control"
                    id="phone"
                    placeholder="Your Phone"
                  />
                </div>

                <div class="form-group">
                  <label for="email">Email</label>
                  <input
                    type="email"
                    v-model="email"
                    class="form-control"
                    id="email"
                    aria-describedby="emailHelp"
                    placeholder="Your email"
                  />
                </div>
                <div class="form-group">
                  <label for="password">Password</label>
                  <input
                    type="password"
                    v-model="password"
                    class="form-control"
                    id="password"
                    placeholder="Password"
                  />
                </div>

                <div class="form-group">
                  <p class="text-center">
                    <button class="btn btn-primary" @click="register">
                      Signup
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { fb, db, auth, firebaseConfig, secondary } from "../firebase";
import { dbSchema } from "../store";
export default {
  name: "CreateUser",
  props: {
    msg: String,
    onCreate: Function
  },
  data() {
    return {
      modalType: "register",
      name: null,
      address: null,
      phone: null,
      email: null,
      password: null,
      zone: null,
      role: null,
    };
  },
  methods: {
    setModalType(type) {
      this.modalType = type;
    },
    setEmail(email) {
      this.email = email;
    },
    register() {
      var secondaryApp = secondary.initializeApp(firebaseConfig, "Secondary");
      secondaryApp.auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then((user) => {
          $("#create_login").modal("hide");
          // Add a new document in collection "uzers"
          // Has nothing to do with adding a new request
          db.collection(dbSchema.users)
            .doc(user.user.uid)
            .set({
              name: this.name,
              email: this.email,
              address: this.address,
              phone: this.phone,
              zone: this.zone,
              role: "User",
            })
            .then(function () {})
            .catch(function (error) {
              console.error("Error writing document: ", error);
            });
            this.onCreate(this.email)
            secondaryApp.auth().signOut();
            
        })
        .catch(function (error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          if (errorCode == "auth/weak-password") {
            alert("The password is too weak.");
          } else {
            alert(errorMessage);
          }
          console.log(error);
        }).finally(() => secondaryApp.delete());
    },
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>